var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-icon',{attrs:{"size":"is-large","icon":"emoticon-sad-outline"}}),_c('h1',{staticClass:"title"},[_vm._v("Page non trouvée.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }